import { useEffect, useRef, useState } from 'react';

export const useSlideDown = (defaultOpen = false) => {
	const [show, setShow] = useState(defaultOpen);
	const slideDownRef = useRef(null);
	const [height, setHeight] = useState(0);

	const toggle = () => {
		setShow(!show);
	};

	const slideUp = () => {
		if (slideDownRef.current) {
			slideDownRef.current.style.height = '0px';
		}
	};

	useEffect(() => {
		if (slideDownRef.current) {
			const element = slideDownRef.current;
			element.style.transition = 'height 0.25s ease-in-out';
			element.style.overflow = 'hidden';

			const updateHeight = () => {
				setHeight(element.scrollHeight);
			};

			updateHeight();

			if (!show) {
				slideUp();
			}

			const resizeObserver = new ResizeObserver(updateHeight);
			resizeObserver.observe(element);

			return () => {
				resizeObserver.unobserve(element);
			};
		}
	}, [show]);

	useEffect(() => {
		if (!slideDownRef.current || height === 0) {
			return;
		}

		slideDownRef.current.style.height = `${show ? height : 0}px`;
	}, [show, height]);

	return { show, toggle, slideDownRef };
};
